/**
 * Форматирует номер телефона для отправки на бэкенд
 * Преобразует номер в формат: плюс и только цифры
 * @param phone - номер телефона в любом формате
 * @returns отформатированный номер в формате или null, если номер пустой
 */
export const formatPhoneForBackend = (phone: string | null | undefined): string | null => {
  if (!phone) {
    return null;
  }

  // Извлекаем все цифры из номера
  const digits = phone.replace(/\D/g, '');

  if (!digits) {
    return null;
  }

  // Добавляем + в начало
  return `+${digits}`;
};
